export default __webpack_public_path__ + "hazar.0bc86c28.png";